module.exports = __webpack_public_path__ + "img/00428307000350.64efd679.png";